
import {
  Component,
  Input,
  forwardRef,
  HostListener,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchDropdownComponent),
      multi: true,
    },
  ],
})
export class SearchDropdownComponent implements ControlValueAccessor, OnChanges {
  list: any[] = [];
  temp_list: any[] = [];
  keyword: string = '';
  _img: any;
  _label: any;
  _uid: any;

  @Output() afterChange = new EventEmitter<any>();
  // Angular 5: sem `{ static: false }`
  @ViewChild('input') input: ElementRef;

  @Input('size') size: any;
  @Input('img') img: any;
  @Input('label') label: any;
  @Input('defaultLabel') defaultLabel: string = 'Todas';

  @Input('items') set items(value: any[]) {
    this.list = value || [];
    if (this.list && this.list.length > 0) {
      // Garante que _label/_uid já estejam definidos (caso items chegue antes)
      const labelKey = this._label || (typeof this.label !== 'undefined' && this.label !== '' ? this.label : 'name');
      const uidKey = this._uid || (typeof this.uid !== 'undefined' && this.uid !== '' ? this.uid : 'id');

      const uidIsNumber = typeof this.list[0][uidKey] === 'number';
      const defaultUid = uidIsNumber ? 0 : '';

      // Evita inserir duplicado "Todas" repetidamente
      const hasDefault = this.list.length > 0 && this.list[0] && this.list[0][labelKey] === this.defaultLabel;
      if (!hasDefault) {
        this.list.unshift({
          [labelKey]: this.defaultLabel,
          [uidKey]: defaultUid,
        });
      }
    }
    this.temp_list = this.list;
  }

  @Input('uid') uid: any;

  onChange: any = () => {};
  onTouch: any = () => {};

  value: any = 'Todas';
  shown: boolean = false;

  constructor(private ele: ElementRef) {}

  ngOnChanges(): void {
    this._label =
      typeof this.label !== 'undefined' && this.label !== ''
        ? this.label
        : 'name';

    this._img =
      typeof this.img !== 'undefined' && this.img !== '' ? this.img : 'img';

    this._uid =
      typeof this.uid !== 'undefined' && this.uid !== '' ? this.uid : 'id';

    this.value = this.defaultLabel;
  }

  writeValue(value: any): void {
    if (value !== undefined && value !== null) {
      // Percorre a lista temporária para achar o label pelo uid
      this.temp_list.forEach((x: any) => {
        if (x[this._uid] == value) {
          this.value = x[this._label];
        }
      });
    } else {
      // Se vier undefined/null, reseta para o default
      this.value = this.defaultLabel;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // Pode ser chamado a partir do template: (input)="search($event.target.value)"
  search(term: string): void {
    const val = (term || '').toLowerCase();
    const temp = this.temp_list.filter((x: any) => {
      // Garante que toString exista
      const labelStr = (x[this._label] !== undefined && x[this._label] !== null)
        ? String(x[this._label]).toLowerCase()
        : '';
      if (labelStr.indexOf(val) !== -1 || !val) {
        return true;
      }
      return false;
    });
    this.list = temp;
  }

  select(item: any): void {
    this.onChange(item[this._uid]);
    this.value = item[this._label];
    // console.log('value', this.value);
    this.shown = false;
    this.afterChange.emit(item);
  }

  show(): void {
    this.shown = !this.shown;
    setTimeout(() => {
      if (this.input && this.input.nativeElement) {
        this.input.nativeElement.focus();
      }
    }, 200);
  }

  @HostListener('document:click', ['$event'])
  onClick(e: Event): void {
    const target = e.target as HTMLElement;
    if (this.ele && this.ele.nativeElement && target) {
      if (!this.ele.nativeElement.contains(target)) {
        this.shown = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/search-dropdown/search-dropdown.component.ts